import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { Language } from '../models/language.model';

// BOILERPLATE TODO: Remove file if the app doesn't allow language change dynamically
// In that case, we use the environment file to define the language if it's different
// in dev, test or prod
@Injectable({ providedIn: 'root' })
export class LanguagesService {
  http = inject(HttpClient);

  getList(): Observable<Language[]> {
    return this.http.get<Language[]>('Languages');
  }
}
